/**
 * @file supplement.reducer.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 08, 2025 16:23
 */
import * as Actions from 'src/store/actions/supplement.actions';

const initialState = {
    // supplementUpdate
    supplementId: '',
    changeSet: {},

    // supplementEdit
    supplement: {},

    // supplementView
    supplementView: {},

    // dialog openers
    supplementEditDialogOpen: false,
    supplementViewDialogOpen: false,
};

const supplementReducer = (state = initialState, action) => {
    switch (action.type) {

        // supplement.edit.dialog
        // -------------------------------------------------------------------
        case Actions.SUPPLEMENT_EDIT_DIALOG_SET:
            return {
                ...state,
                supplementEditDialogOpen: action.payload,
            };

        // supplement.view.dialog
        // -------------------------------------------------------------------
        case Actions.SUPPLEMENT_VIEW_DIALOG_SET:
            return {
                ...state,
                supplementViewDialogOpen: action.payload,
            };

        // supplement.resets
        // -------------------------------------------------------------------
        case Actions.SUPPLEMENT_VIEW_RESET:
            return {
                ...state,
                supplementView: {},
            };

        // supplement.edit
        // -------------------------------------------------------------------
        case Actions.SUPPLEMENT_EDIT_REQUEST:
            return {
                ...state,
                dataLoaded: false,
                supplement: {},
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.SUPPLEMENT_EDIT_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                supplement: action.payload.supplement,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.SUPPLEMENT_EDIT_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        // supplement.update
        // -------------------------------------------------------------------
        case Actions.SUPPLEMENT_UPDATE_REQUEST:
            return {
                ...state,
                dataLoaded: false,
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.SUPPLEMENT_UPDATE_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                supplementId: action.payload.supplementId,
                changeSet: action.payload.changeSet,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.SUPPLEMENT_UPDATE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        // supplement.view
        // -------------------------------------------------------------------
        case Actions.SUPPLEMENT_VIEW_REQUEST:
            return {
                ...state,
                dataLoaded: false,
                supplementView: {},
                serverErrorExists: false,
                serverMessage: '',
            };

        case Actions.SUPPLEMENT_VIEW_SUCCESS:
            return {
                ...state,
                dataLoaded: true,
                supplementView: action.payload.supplementView,
                serverErrorExists: action.payload.errorExists,
                serverMessage: action.payload.serverMessage,
            };

        case Actions.SUPPLEMENT_VIEW_FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        //*************************/    
        default: {
            return state;
        }
    }
};

export default supplementReducer;
